<template>
  <div @mouseenter="handleHover(unitObject.id, true)" @mouseleave="handleHover(unitObject.id, false)" class="drop--sortable--tree__card" :class="[unitObject.parent !== $route.params.dropID ? 'drop--sortable--tree--card__pallet' : 'drop--sortable--tree--card__topLevel', unitObject.id === drops.hoveredUnit ? 'tree__card--hover': '', inputValueCheck(unitObject.id) ? 'toggled--unit' : '', children.length > 0 ? 'have--children' : '']">
    <template v-if="unitObject.id !== $route.params.dropID">
      <div @click="handleCheck($event, unitObject.id)" :id="uuidIconRef" class="drop--sortable--tree__icon">
        <i :style="{fontSize: '20px'}" :id="uuidIconRef + '_icon'" :class="[inputValueCheck(unitObject.id) ? 'fas fa-check-circle' : 'fas fa-circle' ]"/>
      </div>
      <div class="drop--sortable--tree__info">
        <span class="unit--card--title">{{formatUnitType(unitObject.type)}}</span>
        <span class="unit--card--warning" :style="[weightWarnings(unitObject) ? '' : {visibility: 'hidden'}]">
           <i class="fas fa-exclamation-triangle"></i>
        </span>
        <span class="unit--card--subtitle">{{calculateUnitWeight(unitObject) | roundValueWeight(0)}} Kg</span>
        <span class="unit--card--warning" :style="[dimensionsWarnings(unitObject) ? '' : {visibility: 'hidden'}]">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        <span class="unit--card--subtitle">{{ unitObject.dimensions | dimensionValue }} cm</span>
      </div>
      <div  class="drop--sortable--tree__labels" v-if="unitObject.type === 'CustomBox'">
        <div v-if="unitObject.transport.order != null" class="drop--sortable--tree--labels__item">
          <span>{{unitObject.transport.order.buyer.ref}}</span>
          </div>
          <!-- @click="goToOrderDetail(unitObject.transport.order.seller.ref)"  -->
         <div
          v-if="unitObject.transport.order != null"
          class="drop--sortable--tree--labels__item"
         >
          <span>{{unitObject.transport.order.seller.ref}}</span>
         </div>
         <div
         v-if="unitObject.items != null"
         class="drop--sortable--tree--labels__item">
           <span
            v-if="unitObject.items[0].name != null"
           >{{unitObject.items[0].name}}</span>
           </div>
      </div>
    </template>
    <template >
      <div class="drop--sortable--tree__container" :class="{'drop--container': unitObject.id === $route.params.dropID}" :id="unitObject.id">
        <template v-for="unit in children">
          <DropDetailSortableTree
            :key="unit.id"
            :data-id="unit.id"
            :unitObject="unit"
            :children="unit.children"
            :class="[inputValueCheck(unit.id) ? 'sortable-multiselect' : '', unit.id === computedSelectedUnit.id ? 'selected' : '']"
            @shiftClick="handleShiftClick"
            @resetShiftClick="handleResetShiftClick"
          />
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import { Sortable, MultiDrag } from 'sortablejs'
import { mapState, mapActions, mapGetters } from 'vuex'
import { dropHelpers } from '@/_helpers'
import { uuid } from 'vue-uuid'
Sortable.mount(new MultiDrag())
export default {
  name: 'DropDetailSortableTree',
  props: {
    unitObject: Object,
    children: Array
  },
  data () {
    return {
      uuidIconRef: uuid.v1(),
      listElement: null,
      listSortable: null,
      selectedUnit: null,
      hoveredID: null
    }
  },
  created () {
  },
  mounted () {
    if (this.children.length > 0) {
      this.$nextTick(() => {
        this.initializeSortable()
      })
    }
  },
  methods: {
    ...mapActions({
      toggleUnit: 'toggleUnit',
      toggleAllUnits: 'toggleAllUnits',
      selectUnit: 'selectUnit',
      addDropUnits: 'addDropUnits',
      changeUnitParentID: 'changeUnitParentID',
      removeUnit: 'removeUnit',
      hoverUnit: 'hoverUnit',
      setPalletCalculationWarnings: 'setPalletCalculationWarnings'
    }),
    initializeSortable () {
      if (this.listSortable !== null) {
        this.listSortable.destroy()
      }
      const _self = this
      const listElement = document.getElementById(`${_self.unitObject.id}`)
      this.listSortable = Sortable.create(listElement, {
        group: { name: 'list', pull: true },
        multiDrag: true,
        selectedClass: 'sortable-multiselect',
        ghostClass: 'drop-ghost',
        chosenClass: 'chosen-ghost',
        dragClass: 'drag-class',
        fallbackClass: 'chosen-ghost',
        forceFallback: true,
        dataIdAttr: 'data-id',
        fallbackTolerance: _self.$route.params.dropID === _self.unitObject.id ? 0 : 5,
        emptyInsertThreshold: _self.$route.params.dropID === _self.unitObject.id ? 0 : 5,
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        store: {
          get: (sortable) => {
          },
          set: (sortable) => {
          }
        },
        onSelect: (evt) => {
          Sortable.utils.nextTick(() => {
            if (!_self.inputValueCheck(evt.item.getAttribute('data-id'))) {
              Sortable.utils.deselect(evt.item)
            } else {
            }
          })
        },
        onChoose: (evt) => {
          const clickedEl = document.elementFromPoint(evt.originalEvent.clientX, evt.originalEvent.clientY)
          if (clickedEl.getAttribute('id') === null) {
            _self.handleSelectUnit(evt.item.getAttribute('data-id'))
            if (!_self.inputValueCheck(evt.item.getAttribute('data-id'))) {
              _self.$nextTick(() => {
                evt.item.classList.remove('sortable-multiselect')
              })
              Sortable.utils.deselect(evt.item)
            }
          } else if (clickedEl.getAttribute('id').includes(this.uuidIconRef)) {
          } else {
            _self.handleSelectUnit(evt.item.getAttribute('data-id'))
            if (!_self.inputValueCheck(evt.item.getAttribute('data-id'))) {
              _self.$nextTick(() => {
                evt.item.classList.remove('sortable-multiselect')
              })
              Sortable.utils.deselect(evt.item)
            }
          }
        },
        onAdd: ({ item, to, from, newIndex, oldIndex, items, oldIndicies, newIndicies }) => {
          let childrenArray = []
          if (items.length > 0) {
            items.forEach((item) => {
              const childID = item.getAttribute('data-id')
              if (_self.inputValueCheck(item.getAttribute('data-id')) && item.classList.value.indexOf('sortable-multiselect') > -1) {
                childrenArray.push(_self.drops.dropUnitsHash[childID])
                item.classList.remove('sortable-multiselect')
              }
            })
          } else {
            const childID = item.getAttribute('data-id')
            childrenArray.push(_self.drops.dropUnitsHash[childID])
          }
          const containerID = to.getAttribute('id') === _self.$route.params.dropID ? from.getAttribute('id') : to.getAttribute('id')
          _self.changeUnitParentID({ oldParent: from.getAttribute('id'), parent: to.getAttribute('id'), units: childrenArray, containerID: containerID, dropID: _self.$route.params.dropID })
          _self.handleToggleAll('remove')
        },
        onUpdate: ({ from, item, newIndex, oldIndex, items, oldIndicies, newIndicies }) => {
          _self.handleToggleAll('remove')
        },
        onEnd: ({ to, from, item, items }) => {
          if (to.getAttribute('id') !== from.getAttribute('id')) {
            Sortable.utils.nextTick(() => {
              if (items.length > 0) {
                items.forEach((item) => {
                  if (item.parentNode !== null) {
                    item.parentNode.removeChild(item)
                  }
                })
              }
            })
          }
        }
      })
    },
    handleCheck (evt, unitID) {
      if (evt.shiftKey) {
        this.$emit('shiftClick', { unitID })
      } else {
        this.$emit('resetShiftClick')
        this.toggleUnit({ unitID })
      }
    },
    handleShiftClick (unitID) {
      this.$emit('shiftClick', { unitID, unitsList: this.listSortable.toArray() })
    },
    handleResetShiftClick () {
      this.$emit('resetShiftClick')
    },
    deleteEmptyPallet (unitID) {
      this.selectUnit({ unit: null })
      this.removeUnit({ unitID: unitID, dropID: this.$route.params.dropID })
    },
    inputValueCheck (unitID) {
      return this.getToggleUnitIndex(unitID) > -1
    },
    handleToggleAll (toggleState) {
      const units = []
      this.toggleAllUnits({ toggleState, units })
    },
    handleSelectUnit (unitID) {
      this.selectUnit({ unit: this.drops.dropUnitsHash[unitID] })
    },
    formatUnitType (type) {
      if (type === 'CustomBox') {
        return this.$t('packages_type.box')
      } else {
        return this.$t('packages_type.pallet')
      }
    },
    calculateUnitWeight (unit) {
      return dropHelpers.calculateUnitWeight(unit)
    },
    weightWarnings (unit) {
      if (unit.warnings !== undefined) {
        if (unit.warnings.length > 0) {
          let warningMsg = unit.warnings.map(({ msg }) => msg)
          return warningMsg.indexOf('max_weight_exceeded') >= 0
        }
      }
      return false
    },
    dimensionsWarnings (unit) {
      if (unit.warnings !== undefined) {
        if (unit.warnings.length > 0) {
          let warningMsg = unit.warnings.map(({ msg }) => msg)
          return warningMsg.indexOf('max_width_exceeded') >= 0 || warningMsg.indexOf('max_length_exceeded') >= 0
        }
      }
      return false
    },
    countUnits (unit) {
      let totalUnits = 0
      if (unit.children.length > 0) {
        return (totalUnits + unit.children.length) + ` ${this.formatUnitType(unit.children[0].type)}`
      } else {
        if (unit.items !== null) {
          return (totalUnits + unit.items.length) + ' items'
        } else {
          return '0 items'
        }
      }
    },
    handleHover (id, flag) {
      if (id !== this.$route.params.dropID) {
        if (flag) {
          this.hoverUnit({ hoveredID: id })
        } else {
          if (this.unitObject.parent !== this.$route.params.dropID) {
            this.hoverUnit({ hoveredID: this.unitObject.parent })
          }
        }
      } else {
        this.hoverUnit({ hoveredID: null })
      }
    },
    goToOrderDetail (orderRef) {
      this.$router.push({ name: 'OrderDetail', params: { orderID: orderRef } })
    }
  },
  computed: {
    ...mapState(['drops']),
    ...mapGetters([
      'getToggleUnitIndex',
      'getToggleAllState',
      'getUnitsChildren',
      'getDropTree',
      'getSelectedUnit'
    ]),
    computedSelectedUnit: function () {
      const selected = this.getSelectedUnit
      if (selected === null) {
        return { id: null }
      }
      return selected
    }
  },
  watch: {
    children: function (newValue, oldValue) {
      if (this.listSortable !== null) {
        const order = newValue.map(({ id }) => id)
        this.listSortable.sort(order)
      }
    },
  },
  beforeDestroy () {
    if (this.listSortable !== null) {
      this.listSortable.destroy()
    }
  }
}
</script>
<style lang="scss" scoped>
.chosen-ghost {
  visibility: hidden;
}
.drag-class {
  // background-attachment: yellow;
}
.drop-ghost {
  // background-color: red;
}
</style>
